export const showActiveNRegisteredClientIds = [8785, 4493, 7272];
export const RESTRICTED_COMPANEY_IDS = [6926];
export const SHOW_REGISTERED_USERS = [8785, 2244];
